<template>
    <div class="search-group layout10" :class="isMobileSize ? 'mobile' : ''">
        <div v-if="searchGroupTabs.length > 1" class="tab-header">
            <ul class="tab-header-ul">
                <li
                    :class="`option ${activeIndex === index ? 'active' : ''}`"
                    @click="changeType(index)"
                    :key="item.value"
                    v-for="(item, index) in searchGroupTabs"
                    v-html="item.name"
                ></li>
            </ul>
        </div>
        <div class="tab-body">
            <div
                v-for="(item, index) in searchGroupTabs"
                :key="item.id"
                :class="`tab-content ${activeIndex === index ? 'active' : ''}`"
            >
                <component
                    :is="searchBar"
                    v-if="item.inputComponentType === 'searchBar'"
                    v-show="activeIndex === index"
                    :placeholder="searchGroupConfig['placeholder-search']"
                    :submitText="item.submitText"
                />
                <address-input
                    v-if="item.inputComponentType === 'addressInput'"
                    v-show="activeIndex === index"
                    :placeholder="
                        searchGroupConfig[
                            item.id === 1
                                ? 'placeholder-sell'
                                : 'placeholder-eval'
                        ]
                    "
                    v-model:searchText="searchText"
                    :submitText="item.submitText"
                    :chooseSuggestionAutoSubmit="false"
                    :mobileScroll="false"
                    :theme="'layout10'"
                    icon="icon-search"
                    @submitAddress="
                        (address, data, callback) =>
                            submitAddress(
                                { address, data, callback },
                                index,
                                item.submitType,
                                item.submitUrl
                            )
                    "
                />
            </div>
        </div>
        <div
            v-if="agreementData && agreementData.agreement"
            class="agreement-container"
        >
            <a
                :href="agreementData.agreementUrl || ''"
                class="agreement"
                target="_blank"
                rel="noopener"
            >{{ agreementData.agreement }}</a
            >
        </div>
    </div>
</template>

<script>
import common from '../search-group';
import mixinsSearchBar from './mixins-search-bar';
import AddressInput from '../../../components/address-input/standard.vue';
export default {
    mixins: [common, mixinsSearchBar],
    data: function() {
        return {
            offset: [0, 3],
            activeIndex: 0
        };
    },
    components: {
        AddressInput
    },
    mounted() {},
    methods: {
        changeType(i) {
            this.activeIndex = i;
        }
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '@/theme/mixin.scss';
.search-group.layout10 {
    --input-height: 50px;
    --radius: 5px;
    width: 100%;
    @include placeholderMix(var(--font-normal), #a8a8a8, 16px);
    @include media-600 {
        @include placeholderMix(var(--font-normal), #a8a8a8, 14px);
    }
    .tab-header {
        display: flex;
        height: 50px;
    }
    .tab-header-ul {
        height: 100%;
        background: #fff;
        display: inline-flex;
        box-shadow: 0px -5px 5px rgba(25, 25, 25, 0.02);
        pointer-events: auto;
        .option {
            height: 100%;
            line-height: 50px;
            font-size: 16px;
            font-family: var(--font-normal);
            position: relative;
            min-width: 149px;
            text-align: center;
            color: var(--g-primary-color);
            cursor: pointer;
            &.active {
                background: var(--g-btn-background);
                font-family: var(--font-bold);
                color: var(--g-btn-color);
            }
        }
    }

    .tab-body {
        max-width: calc(100vw - 100px);
        width: 1000px;
        box-shadow: 0px 4px 30px rgba(25, 25, 25, 0.08);
        pointer-events: auto;
        .tab-content {
            width: 100%;
            display: none;
            background: #fff;
            padding: 10px 20px;
            &.active {
                display: block;
                .address-input {
                    height: var(--input-height);
                    width: 100%;
                    box-shadow: none;
                    align-items: center;
                    @include media-600 {
                        background-color: transparent;
                        &.standard .left-box .icon-search {
                            display: none;
                        }
                    }
                    .left-box {
                        @include placeholderMix(
                            var(--font-normal),
                            #a8a8a8,
                            16px
                        );
                        @include media-600 {
                            @include placeholderMix(
                                var(--font-normal),
                                #a8a8a8,
                                14px
                            );
                        }
                    }
                    .left-box input {
                        padding-left: 20px;
                        font-family: var(--font-medium);
                        font-size: 16px;
                        color: var(--g-primary-color);
                        @include media-600 {
                            padding-left: 10px;
                            padding-right: 10px;
                            font-size: 14px;
                        }
                    }

                    .right-box {
                        .submit-btn {
                            @include color-button-hover();
                            line-height: var(--input-height);
                            height: 50px;
                            @include color-button();
                            background: var(--g-btn-background);
                            color: var(--g-btn-color);
                            .iconfont {
                                display: none;
                            }
                        }
                        @include media-800 {
                            display: block;
                            width: 50px;
                            padding: 0;
                            text-align: center;
                            .submit-btn {
                                width: 100%;
                                .iconfont {
                                    font-size: 24px;
                                    display: block;
                                    font-weight: 600;
                                }
                                .submit {
                                    display: none;
                                }
                            }
                        }
                    }
                }
            }

            .search-bar {
                background-color: transparent;
                width: 100%;
                padding: 0;
                margin-top: 0;
            }
            input {
                height: var(--input-height);
                width: 100%;
                box-shadow: none;
                // padding-left: 20px;
            }
        }
    }
    .agreement-container {
        width: 100%;
        margin-top: 20px;
        .agreement {
            width: 100%;
            font-size: 12px;
            text-align: center;
            @include webkitBox(3);
            line-height: 14px;
            color: #fff;
            &:hover {
                @include color-hover();
                @include media-800 {
                    color: #fff;
                }
            }
        }
    }
    @include media-800 {
        .tab-header {
            width: 100%;
            .input_prepend {
                padding: 0 10px;
            }
        }
        .tab-header-ul {
            width: 100%;
            .option {
                flex: 1;
                min-width: 115px;
            }
        }
        .tab-body {
            .tab-content {
                padding: 10px 15px;
            }
        }
    }
}
.search-group.layout10.mobile {
    margin-top: 0px;
    padding-top: 0px;
    .tab-body {
        max-width: 100%;
    }
}
</style>
